// Swaps realted actions
import makePaginatedListActions from './paginated'

export const GET_SWAPS = 'GET_SWAPS'
export const GET_SWAPS_UNLOAD = 'GET_SWAPS_UNLOAD'
export const [loadSwaps, loadMoreSwaps, unloadSwaps] = makePaginatedListActions(
  GET_SWAPS
)

export const GET_SWAP_DETAIL = 'GET_SWAP_DETAIL'
export const GET_SWAP_DETAIL_LOADING = 'GET_SWAP_DETAIL_LOADING'
export const GET_SWAP_DETAIL_SUCCESS = 'GET_SWAP_DETAIL_SUCCESS'
export const GET_SWAP_DETAIL_FAILURE = 'GET_SWAP_DETAIL_FAILURE'
export const GET_SWAP_DETAIL_UNLOAD = 'GET_SWAP_DETAIL_UNLOAD'
export const loadSwapDetail = id => ({
  type: GET_SWAP_DETAIL,
  payload: id,
})

export const UPDATE_SWAP = 'UPDATE_SWAP'
export const UPDATE_SWAP_LOADING = 'UPDATE_SWAP_LOADING'
export const UPDATE_SWAP_SUCCESS = 'UPDATE_SWAP_SUCCESS'
export const UPDATE_SWAP_FAILURE = 'UPDATE_SWAP_FAILURE'
export const updateSwap = (swap, reversed = false) => ({
  type: UPDATE_SWAP,
  payload: { swap, reversed },
})

export const unloadSwapDetail = () => ({
  type: GET_SWAP_DETAIL_UNLOAD,
})

export const SWAP_ACTION_ACCEPT = 'SWAP_ACTION_ACCEPT'
export const SWAP_ACTION_ACCEPT_LOADING = 'SWAP_ACTION_ACCEPT_LOADING'
export const SWAP_ACTION_ACCEPT_SUCCESS = 'SWAP_ACTION_ACCEPT_SUCCESS'
export const SWAP_ACTION_ACCEPT_FAILURE = 'SWAP_ACTION_ACCEPT_FAILURE'
export const acceptSwap = (swapId, updatedAt) => ({
  type: SWAP_ACTION_ACCEPT,
  payload: { swapId, updatedAt },
})

export const SWAP_ACTION_REJECT = 'SWAP_ACTION_REJECT'
export const SWAP_ACTION_REJECT_LOADING = 'SWAP_ACTION_REJECT_LOADING'
export const SWAP_ACTION_REJECT_SUCCESS = 'SWAP_ACTION_REJECT_SUCCESS'
export const SWAP_ACTION_REJECT_FAILURE = 'SWAP_ACTION_REJECT_FAILURE'
export const rejectSwap = (swapId, reason, updatedAt) => ({
  type: SWAP_ACTION_REJECT,
  payload: { swapId, reason, updatedAt },
})

export const SWAP_ACTION_CANCEL = 'SWAP_ACTION_CANCEL'
export const SWAP_ACTION_CANCEL_LOADING = 'SWAP_ACTION_CANCEL_LOADING'
export const SWAP_ACTION_CANCEL_SUCCESS = 'SWAP_ACTION_CANCEL_SUCCESS'
export const SWAP_ACTION_CANCEL_FAILURE = 'SWAP_ACTION_CANCEL_FAILURE'
export const cancelSwap = swapId => ({
  type: SWAP_ACTION_CANCEL,
  payload: { swapId },
})

export const SWAP_ACTION_HIDE = 'SWAP_ACTION_HIDE'
export const SWAP_ACTION_HIDE_LOADING = 'SWAP_ACTION_HIDE_LOADING'
export const SWAP_ACTION_HIDE_SUCCESS = 'SWAP_ACTION_HIDE_SUCCESS'
export const SWAP_ACTION_HIDE_FAILURE = 'SWAP_ACTION_HIDE_FAILURE'
export const hideSwap = swapId => ({
  type: SWAP_ACTION_HIDE,
  payload: { swapId },
})

export const SWAP_ACTION_FEEDBACK = 'SWAP_ACTION_FEEDBACK'
export const SWAP_ACTION_FEEDBACK_LOADING = 'SWAP_ACTION_FEEDBACK_LOADING'
export const SWAP_ACTION_FEEDBACK_SUCCESS = 'SWAP_ACTION_FEEDBACK_SUCCESS'
export const SWAP_ACTION_FEEDBACK_FAILURE = 'SWAP_ACTION_FEEDBACK_FAILURE'
export const feedbackSwap = (swapId, userId, rating, reason) => ({
  type: SWAP_ACTION_FEEDBACK,
  payload: { swapId, userId, rating, reason },
})

export const SWAP_ACTION_ARCHIVE = 'SWAP_ACTION_ARCHIVE'
export const SWAP_ACTION_ARCHIVE_LOADING = 'SWAP_ACTION_ARCHIVE_LOADING'
export const SWAP_ACTION_ARCHIVE_SUCCESS = 'SWAP_ACTION_ARCHIVE_SUCCESS'
export const SWAP_ACTION_ARCHIVE_FAILURE = 'SWAP_ACTION_ARCHIVE_FAILURE'
export const archiveSwap = (swapId, userId) => ({
  type: SWAP_ACTION_ARCHIVE,
  payload: { swapId, userId },
})

export const GET_NEW_SWAP_DATA = 'GET_NEW_SWAP_DATA'
export const GET_NEW_SWAP_DATA_LOADING = 'GET_NEW_SWAP_DATA_LOADING'
export const GET_NEW_SWAP_DATA_SUCCESS = 'GET_NEW_SWAP_DATA_SUCCESS'
export const GET_NEW_SWAP_DATA_FAILURE = 'GET_NEW_SWAP_DATA_FAILURE'
export const GET_NEW_SWAP_DATA_UNLOAD = 'GET_NEW_SWAP_DATA_UNLOAD'
export const loadNewSwap = (
  destinatarioId,
  destinatarioItemsIds = [],
  proponenteItemsIds = [],
  money = 0
) => ({
  type: GET_NEW_SWAP_DATA,
  payload: { destinatarioId, destinatarioItemsIds, proponenteItemsIds, money },
})
export const unloadNewSwap = () => ({
  type: GET_NEW_SWAP_DATA_UNLOAD,
})

const makeEditSwapActions = typePrefix => {
  const addItemProponente = item => ({
    type: `${typePrefix}_ADD_ITEM_PROPONENTE`,
    payload: item,
  })
  const addItemDestinatario = item => ({
    type: `${typePrefix}_ADD_ITEM_DESTINATARIO`,
    payload: item,
  })

  const removeItemDestinatario = item => ({
    type: `${typePrefix}_REMOVE_ITEM_DESTINATARIO`,
    payload: item,
  })
  const removeItemProponente = item => ({
    type: `${typePrefix}_REMOVE_ITEM_PROPONENTE`,
    payload: item,
  })

  const setMoneyProponente = money => ({
    type: `${typePrefix}_SET_MONEY_PROPONENTE`,
    payload: +money,
  })
  const setMoneyDestinatario = money => ({
    type: `${typePrefix}_SET_MONEY_DESTINATARIO`,
    payload: +money,
  })

  return [
    addItemProponente,
    addItemDestinatario,
    removeItemProponente,
    removeItemDestinatario,
    setMoneyProponente,
    setMoneyDestinatario,
  ]
}

export const [
  newSwapAddItemProponente,
  newSwapAddItemDestinatario,
  newSwapRemoveItemProponente,
  newSwapRemoveItemDestinatario,
  newSwapSetMoneyProponente,
  newSwapSetMoneyDestinatario,
] = makeEditSwapActions('NEW_SWAP')

export const [
  swapAddItemProponente,
  swapAddItemDestinatario,
  swapRemoveItemProponente,
  swapRemoveItemDestinatario,
  swapSetMoneyProponente,
  swapSetMoneyDestinatario,
] = makeEditSwapActions('SWAP')

export const SWAP_RESET = 'SWAP_RESET'
export const resetSwap = () => ({
  type: SWAP_RESET,
})

export const SWAP_REVERSE = 'SWAP_REVERSE'
export const reverseSwap = () => ({
  type: SWAP_REVERSE,
})

export const CREATE_NEW_SWAP = 'CREATE_NEW_SWAP'
export const CREATE_NEW_SWAP_LOADING = 'CREATE_NEW_SWAP_LOADING'
export const CREATE_NEW_SWAP_SUCCESS = 'CREATE_NEW_SWAP_SUCCESS'
export const CREATE_NEW_SWAP_FAILURE = 'CREATE_NEW_SWAP_FAILURE'
export const createNewSwap = swap => ({
  type: CREATE_NEW_SWAP,
  payload: swap,
  successMessage: 'Proposta di scambio inviata',
})



// WEBPACK FOOTER //
// ./src/actions/swaps.js